import { reatomAsync } from "@reatom/async";
import { API } from "src/api.ts";

import { listWatermarksRequest } from "./listWatermarksRequest";

export const deleteWatermarkRequest = reatomAsync(
  async (ctx, id: string) => {
    await API.objectStorageApi.objectStorageControllerDeleteWatermark(id, {
      signal: ctx.controller.signal,
    });
  },
  {
    name: "deleteWatermarkRequest",
    onFulfill: (ctx) => listWatermarksRequest(ctx),
  },
);
